// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSettingPerformanceGoal')
class Toolbox__GoalSettingPerformanceGoal {
    @jsonProperty(() => Toolbox__GoalSettingPerformanceGoal.Id)
    id: Toolbox__GoalSettingPerformanceGoal.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting", "goalSettingId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting", "goalSettingId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting", "goalSettingId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "order": "number", "goalDescription": "string", "rejectionComment": "string", "selfRating": "string", "managerRating": "string", "goalSetting": "Toolbox.GoalSetting", "goalSettingId": "Toolbox.GoalSetting.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "goalDescription"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ goalSetting: () => Toolbox.GoalSetting } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θorder = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θgoalDescription = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrejectionComment = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θselfRating = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θmanagerRating = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θgoalSetting = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSettingId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSettingPerformanceGoal' {
        return 'Toolbox.GoalSettingPerformanceGoal'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSettingPerformanceGoal' {
        return 'Toolbox.GoalSettingPerformanceGoal'
    }

    static get __baseType(): 'Toolbox.GoalSettingPerformanceGoal' {
        return 'Toolbox.GoalSettingPerformanceGoal'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSettingPerformanceGoal' {
        return 'Toolbox.GoalSettingPerformanceGoal'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSettingPerformanceGoal[BoInfoSymbol]
    }

    get order(): number {
        return this.θorder?.()
    }

    set order(order) {
        this.θorder.set(LowgileDataUtil.coerceDataType(order, 'number', false, true))
    }

    get goalDescription(): string {
        return this.θgoalDescription?.()
    }

    set goalDescription(goalDescription) {
        this.θgoalDescription.set(LowgileDataUtil.coerceDataType(goalDescription, 'string', false, true))
    }

    get rejectionComment(): string {
        return this.θrejectionComment?.()
    }

    set rejectionComment(rejectionComment) {
        this.θrejectionComment.set(LowgileDataUtil.coerceDataType(rejectionComment, 'string', false, true))
    }

    get selfRating(): string {
        return this.θselfRating?.()
    }

    set selfRating(selfRating) {
        this.θselfRating.set(LowgileDataUtil.coerceDataType(selfRating, 'string', false, true))
    }

    get managerRating(): string {
        return this.θmanagerRating?.()
    }

    set managerRating(managerRating) {
        this.θmanagerRating.set(LowgileDataUtil.coerceDataType(managerRating, 'string', false, true))
    }

    get goalSetting(): Toolbox.GoalSetting {
        return this.θgoalSetting?.()
    }

    set goalSetting(goalSetting) {
        this.θgoalSetting.set(LowgileDataUtil.coerceDataType(goalSetting, Toolbox.GoalSetting, false, true))
        if (goalSetting) {
            this.θgoalSettingId.set(goalSetting.id)
        } else if (goalSetting === null && goalSetting) {
            this.θgoalSettingId.set(null)
        }
    }

    get goalSettingId(): Toolbox.GoalSetting.Id {
        return this.θgoalSettingId?.()
    }

    set goalSettingId(goalSettingId) {
        if (goalSettingId === null) this.θgoalSetting.set(null)
        if (this.goalSetting?.id && goalSettingId != this.goalSetting.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSettingId.set(LowgileDataUtil.coerceDataType(goalSettingId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSettingPerformanceGoal>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSettingPerformanceGoal()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSettingPerformanceGoal>, restrictToClass?: Class<Partial<Toolbox__GoalSettingPerformanceGoal>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            order: z.number(),
            goalDescription: z.string(),
            rejectionComment: z.string(),
            selfRating: z.string(),
            managerRating: z.string(),
            get goalSetting() { return Toolbox.GoalSetting.$getSchema() },
            get goalSettingId() { return z.number() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSettingPerformanceGoal.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('order', 'goalDescription', 'rejectionComment', 'selfRating', 'managerRating', 'goalSetting', 'goalSettingId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSettingPerformanceGoal {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSettingPerformanceGoal { }

export import GoalSettingPerformanceGoal = Toolbox__GoalSettingPerformanceGoal
setTimeout(() => {
    jsonProperty(() => Number)(Toolbox__GoalSettingPerformanceGoal.prototype, 'order')
    jsonProperty(() => String)(Toolbox__GoalSettingPerformanceGoal.prototype, 'goalDescription')
    jsonProperty(() => String)(Toolbox__GoalSettingPerformanceGoal.prototype, 'rejectionComment')
    jsonProperty(() => String)(Toolbox__GoalSettingPerformanceGoal.prototype, 'selfRating')
    jsonProperty(() => String)(Toolbox__GoalSettingPerformanceGoal.prototype, 'managerRating')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingPerformanceGoal.prototype, 'goalSetting')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingPerformanceGoal.prototype, 'goalSettingId')
    jsonProperty(() => Date)(Toolbox__GoalSettingPerformanceGoal.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingPerformanceGoal.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingPerformanceGoal.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingPerformanceGoal.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingPerformanceGoal.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingPerformanceGoal.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSettingPerformanceGoal.prototype, 'versionNumber')
})

export const GoalSettingPerformanceGoalθId = Number;

export type GoalSettingPerformanceGoalθId = number;

namespace Toolbox__GoalSettingPerformanceGoal {
    export type Id = NominalType<number, 'Toolbox.GoalSettingPerformanceGoal'>

}
